import { useAxiosInstance } from '@/services/httpInstance';

const useGetPermitions = ({username}: {username: string}) => {
  const [{ loading, data, error }, getUserPermissions] = useAxiosInstance(
    {
      url: `/back-office/v1/roles/findByUserName/${username}`,
      method: 'GET',
    }
  );

  return {
    loading,
    data,
    error,
    getUserPermissions,
  };
};

export default useGetPermitions;
